import React from 'react';
import { Switch } from '@mui/material';
import './MirrorToggle.scss';

/**
 * Przełącznik „Odbicie lustrzane” - ten sam w panelu generowania i w obu edytorach.
 * @param {{ checked: boolean, onChange: Function, disabled?: boolean, className?: string }} props
 */
export default function MirrorToggle({ checked, onChange, disabled = false, className = '' }) {
    return (
        <label className={`mirrorToggle ${className}`}>
            <Switch
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                inputProps={{ 'aria-describedby': 'mirror-toggle-hint' }}
            />
            <span>
                <strong>Odbicie lustrzane</strong>
                <small id="mirror-toggle-hint">Włącz przy druku sublimacyjnym lub termotransferowym.</small>
            </span>
        </label>
    );
}
